module.exports = __webpack_public_path__ + "a6a88883aa24bd6881f928115b3f2f91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/rbc_global_asset_management_.png
// module id = 1714
// module chunks = 0